import { render, staticRenderFns } from "./materialComponent.vue?vue&type=template&id=e287e4b8&scoped=true&"
import script from "./materialComponent.vue?vue&type=script&lang=js&"
export * from "./materialComponent.vue?vue&type=script&lang=js&"
import style0 from "./materialComponent.vue?vue&type=style&index=0&id=e287e4b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e287e4b8",
  null
  
)

export default component.exports